import React, { Component } from 'react'
import LandingPageView from '../components/Landing/LandingPageView'

interface LandingPageProps {
  LogoData: any;
}
interface LandingPageState {
  LogosList: any; 
}
export default class LandingPage extends Component<LandingPageProps, LandingPageState> {

  constructor(props: LandingPageProps) {
    super(props);
    this.state = {
      LogosList: props.LogoData, // Initialize LogosList with the passed logoData
    };
  }
  // componentDidMount(): void {
  //   this.sstate.LogosList(LogoData)
  // }

  componentDidUpdate(prevProps: Readonly<LandingPageProps>, prevState: Readonly<LandingPageState>, snapshot?: any): void {
    if(prevProps!=this.props){
         this.setState({LogosList:this.props.LogoData})
    }
  }


  render() {
    return (
      <div className='landing-page'><LandingPageView LogoData={this.state.LogosList}/></div>
    )
  }
}
